const indexItems = [
  { title: '热血漫画精选', count: '326部', desc: '燃到爆炸的热血全本漫画合集', icon: 'ri-fire-line' },
  { title: '恋爱漫画推荐', count: '288部', desc: '甜蜜浪漫的恋爱故事一网打尽', icon: 'ri-heart-line' },
  { title: '韩漫精品专区', count: '512部', desc: '精致画风韩漫全集免费阅读', icon: 'ri-chat-smile-2-line' },
  { title: '日漫经典巨作', count: '436部', desc: '日漫经典全本漫画完整版合集', icon: 'ri-earth-line' },
  { title: '国漫崛起之作', count: '198部', desc: '优秀国漫完整版下拉式阅读', icon: 'ri-flag-line' },
  { title: '悬疑推理合集', count: '174部', desc: '烧脑悬疑全本漫画一次看够', icon: 'ri-search-eye-line' },
  { title: '奇幻冒险天地', count: '245部', desc: '异世界奇幻全本漫画大全', icon: 'ri-magic-line' },
  { title: '校园青春系列', count: '156部', desc: '校园日常与青春回忆全收录', icon: 'ri-school-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-4">
          主题索引 · 专题合集
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-xl mx-auto">
          按主题快速发现好看的漫画，韩漫日漫国漫分类索引
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group bg-background-50 rounded-xl p-5 border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="flex items-center justify-between mb-3">
                <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-lg group-hover:bg-accent-200 transition-colors">
                  <i className={`${item.icon} text-accent-600 text-lg`}></i>
                </div>
                <span className="text-xs text-foreground-500 bg-background-100 px-2 py-1 rounded-full whitespace-nowrap">
                  {item.count}
                </span>
              </div>
              <h3 className="font-heading text-base text-foreground-900 mb-1">{item.title}</h3>
              <p className="text-sm text-foreground-500">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}